import { v4 as uuidv4 } from 'uuid'
import { ColItem } from './interfaces'

export function getDefaultCnCols(): ColItem[] {
  const colNames = [
    'siren',
    'entreprise',
    'metiers',
    'postal_code',
    'city',
    'selected',
    'statut',
    'latest_ca',
    'achats_accessibles',
    'ca_scan',
    'ca_objectif',
    'comment',
  ]
  const cols: ColItem[] = colNames.map((name, index) => ({
    id: uuidv4(),
    coltype: 'coldebase',
    name,
    rank: index,
    displayInTable: name !== 'latest_ca' && name !== 'comment',
    filterInMap: false,
    list_pdv_btn_filter: false,
  }))

  const extraCols: Array<{ name: string; options?: ColItem['options']; selectValue?: ColItem['selectValue'] }> = [
    { name: 'rge' },
    { name: 'ms', selectValue: undefined },
    { name: 'rdv', selectValue: undefined },
    { name: 'dep_number', selectValue: undefined },
    { name: 'cs_fake', selectValue: undefined },
    { name: 'cs', selectValue: undefined },
    { name: 'fournisseurs_concurrents', options: [] },
    { name: 'keywords', selectValue: [] },
    { name: 'effectif_site', selectValue: [] },
    { name: 'ape_code', selectValue: undefined },
    { name: 'create_date', selectValue: undefined },
  ]

  extraCols.forEach((col, offset) => {
    cols.push({
      id: uuidv4(),
      coltype: 'coldebase',
      name: col.name,
      rank: colNames.length + offset,
      displayInTable: false,
      filterInMap: false,
      list_pdv_btn_filter: false,
      options: col.options,
      selectValue: col.selectValue,
    })
  })

  return cols
}
